import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { Button, Card, Spinner } from "../../../shared";
import { CardHeader } from "../../../shared/Card/CardHeader";
import { capitalizeFirstLetter } from "../../../utils";

/**
 * Payment method summary for self-serve Stripe billing.
 */
export const BillingPaymentMethod = ({
  loading = false,
  collectionMethod = "manual_invoice",
  selectedPaymentMethod = null,
  canManagePortal = false,
  portalLoading = false,
  onManageBilling,
}) => {
  if (collectionMethod === "manual_invoice") {
    return null;
  }

  const payMethodType = selectedPaymentMethod?.type;
  const payMethod = selectedPaymentMethod?.[payMethodType] || {};
  const isCard = payMethodType === "card";
  const isBank = payMethodType === "us_bank_account";

  return (
    <Card
      header={
        <CardHeader
          title="Payment method"
          actions={
            canManagePortal ? (
              <Button
                title={portalLoading ? "Opening..." : "Update"}
                type="light"
                size="xs"
                onClick={onManageBilling}
                disabled={portalLoading}
              />
            ) : null
          }
        />
      }
      content={
        loading ? (
          <Spinner />
        ) : !selectedPaymentMethod ? (
          <p className="text-sm text-gray-600">
            No card or bank account on file yet. Start a subscription or open billing settings to
            add one.
          </p>
        ) : (
          <div className="rounded-lg border border-gray-200 p-4">
            <div className="text-sm font-semibold text-gray-800">
              {isBank
                ? "Bank account"
                : payMethod?.brand
                ? capitalizeFirstLetter(payMethod.brand)
                : "Payment method"}
            </div>
            <div className="mt-1 text-sm text-gray-700">
              {isBank && payMethod.bank_name}
              {isCard && `Card ending in ${payMethod.last4}`}
              {isBank && !isCard && `Ending in ${payMethod.last4}`}
            </div>
            <div className="mt-1 text-xs text-gray-500">
              {isCard && `Expires ${payMethod.exp_month}/${payMethod.exp_year}`}
            </div>
            <div className="mt-2 flex items-center text-xs text-gray-500">
              <EnvelopeIcon className="mr-1 h-3 w-3" />
              {selectedPaymentMethod?.billing_details?.email || "Billing email on file with Stripe"}
            </div>
          </div>
        )
      }
    />
  );
};
